module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Verified-e84f63a7b53c1473eb3d536d7ac4c02c.svg";